import type { SVGProps } from 'react';

const Recertification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M6.49984 17.3337H11.4998C15.6665 17.3337 17.3332 15.667 17.3332 11.5003V6.50033C17.3332 2.33366 15.6665 0.666992 11.4998 0.666992H6.49984C2.33317 0.666992 0.666504 2.33366 0.666504 6.50033V11.5003C0.666504 15.667 2.33317 17.3337 6.49984 17.3337Z"
      stroke="#292D32"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default Recertification;
